export const mainNavItems = [
  { name: 'Voices ', url: '/voices' },
  { name: 'Pricing ', url: '/pricing' },
  { name: 'Get Started', url: 'https://my.tayl.app', isHighlighted: true },
]

export const numSupportedLanguages = 40
export const numSupportedVoices = 300
export const numSupportedStandardVoicesEn = 21
